import React, { useEffect, useState } from "react";
import PageHeader from "@/components/PageHeader";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { ClipboardList, ArrowRight } from "lucide-react";

const TYPES = ["dossier", "reclamation", "appel", "client", "document"];

export default function Historique() {
  const [rows, setRows] = useState([]);
  const [type, setType] = useState("all");

  const load = async () => {
    const params = { limit: 300 };
    if (type !== "all") params.entity_type = type;
    const { data } = await api.get("/historique", { params });
    setRows(data);
  };
  useEffect(() => { load(); }, [type]);

  return (
    <div>
      <PageHeader
        eyebrow="Traçabilité"
        title="Historique & audit"
        description="Toutes les actions horodatées effectuées sur la plateforme."
        testid="historique-header"
        actions={
          <Select value={type} onValueChange={setType}>
            <SelectTrigger className="w-48" data-testid="historique-type-filter"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Toutes les entités</SelectItem>
              {TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
            </SelectContent>
          </Select>
        }
      />

      <Card className="border border-slate-200 bg-white">
        <CardContent className="p-6">
          {rows.length === 0 ? (
            <div className="text-center py-10 text-slate-400">
              <ClipboardList className="w-8 h-8 mx-auto mb-2 opacity-40" /> Aucun événement
            </div>
          ) : (
            <ol className="relative border-l border-slate-200 ml-3">
              {rows.map((h) => (
                <li key={h.id} className="mb-6 ml-6" data-testid={`historique-item-${h.id}`}>
                  <span className="absolute -left-[7px] mt-1.5 w-3 h-3 rounded-full bg-blue-800 ring-4 ring-blue-100"></span>
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <div className="flex items-center gap-2 flex-wrap">
                        <Badge variant="outline" className="text-slate-500">{h.entity_type}</Badge>
                        <span className="font-medium text-slate-900">{h.action}</span>
                        <ArrowRight className="w-3.5 h-3.5 text-slate-400" />
                        <span className="font-mono text-xs text-slate-500">{h.entity_id.slice(0, 8)}</span>
                      </div>
                      {h.details && <div className="text-sm text-slate-600 mt-1">{h.details}</div>}
                      {(h.old_value || h.new_value) && (
                        <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs">
                          {h.old_value && (
                            <div className="border border-red-100 bg-red-50/60 rounded-lg p-2 font-mono">
                              <div className="text-[10px] uppercase tracking-widest text-red-500 mb-1">Ancienne valeur</div>
                              <pre className="whitespace-pre-wrap break-all text-slate-700">{JSON.stringify(h.old_value, null, 0)}</pre>
                            </div>
                          )}
                          {h.new_value && (
                            <div className="border border-emerald-100 bg-emerald-50/60 rounded-lg p-2 font-mono">
                              <div className="text-[10px] uppercase tracking-widest text-emerald-600 mb-1">Nouvelle valeur</div>
                              <pre className="whitespace-pre-wrap break-all text-slate-700">{JSON.stringify(h.new_value, null, 0)}</pre>
                            </div>
                          )}
                        </div>
                      )}
                      <div className="text-xs text-slate-400 mt-2 flex items-center gap-3">
                        <span>par {h.user_name || h.user_id}</span>
                        {h.ip_address && <span className="font-mono">IP {h.ip_address}</span>}
                      </div>
                    </div>
                    <div className="text-xs font-mono text-slate-500 whitespace-nowrap">{new Date(h.created_at).toLocaleString("fr-FR")}</div>
                  </div>
                </li>
              ))}
            </ol>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
